(function () {
  if (window.__carminaAnimInit) return;
  window.__carminaAnimInit = true;

  var revealEls = document.querySelectorAll('.carmina-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('carmina-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('carmina-reveal--visible');
    });
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var parallaxEls = document.querySelectorAll('.carmina-hero__media');

  if (parallaxEls.length && !reduceMotion) {
    var ticking = false;

    function updateParallax() {
      var winH = window.innerHeight;

      parallaxEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var progress = (winH - rect.top) / (winH + rect.height);
        progress = Math.min(Math.max(progress, 0), 1);
        var offset = (progress - 0.5) * 60;
        el.querySelectorAll('.carmina-hero__media-inner').forEach(function (inner) {
          inner.style.setProperty('--carmina-parallax', offset.toFixed(1) + 'px');
        });
      });

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    updateParallax();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }
})();
